import React, { Component } from "react";
import Form from "./Form";
import { compose } from "redux";
import { withUrlResource, withUrlResourceTimezone } from "common/utils";
import Resource from "common/components/Resource";
import client from "common/admin/client";
import { pick } from "lodash";
import { transformApiError } from "common/api/errors";
import resourceFactory from "common/admin/resourceFactory";

const fields = ["name", "icon", "type", "action", "priority"];

class EditQuickLink extends Component {
  constructor(props) {
    super(props);
    this.currentIdRef = React.createRef();
  }
  handleSubmit = async (values, { setSubmitting, setErrors, setStatus }) => {
    const { id } = this.props.urlResource;
    const { notificationId } = this.props.match.params;
    const actions = resourceFactory(`buildings/${id}/quick_links`);
    const body = pick(values, fields);
    try {
      await actions.update(this.currentIdRef.current, {
        links: { ...body, id: Number(notificationId) },
      });
      setStatus({ success: true });
    } catch (error) {
      const errors = transformApiError(error);
      setStatus({ success: false });
      setErrors(errors);
    }
    setSubmitting(false);
  };

  deleteNotification = () => {
    const { match, urlResource } = this.props;
    const { id } = urlResource;
    const url = `buildings/${id}/quick_links/${match.params.notificationId}`;
    client.del(url).then(() => {
      window.location.href = `/building/${id}/quick_links`;
    });
  };

  render() {
    const { match, urlResource } = this.props;
    const { id: resourceId, plural: resourcePlural, timezone } = urlResource;
    return (
      <Resource
        name={`${resourcePlural}/${resourceId}/quick_links/${match.params.notificationId}`}
        queryParams={{}}
        render={({ links, id }) => {
          this.currentIdRef.current = id;
          return (
            <Resource
              name="floors"
              queryParams={{ building_id: urlResource.id }}
              render={(floors) => (
                <Form
                  isEdit
                  floors={floors}
                  deleteNotification={this.deleteNotification}
                  handleSubmit={this.handleSubmit}
                  timezone={timezone}
                  initialValues={{
                    name: links[0]?.name,
                    icon: links[0]?.icon,
                    type: links[0]?.type,
                    action: links[0]?.action,
                    priority: links[0]?.priority,
                  }}
                />
              )}
            />
          );
        }}
      />
    );
  }
}

const enhanced = compose(withUrlResource, withUrlResourceTimezone);

export default enhanced(EditQuickLink);
